module.exports = __webpack_public_path__ + "img/success-image.0135c7e7.png";